import React from "react";
import { Checkbox, Input, InputNumber } from "rsuite";
import {
  buildLuggagesString,
  LUGGAGE_OPTION_LABELS,
  type LuggageOptionLabel,
  type LuggageSelection,
} from "../utilities/luggage";

type Props = {
  value: LuggageSelection;
  onChange: (nextValue: LuggageSelection, formattedValue: string) => void;
};

export default function OrderLuggageSelector({ value, onChange }: Props) {
  const updateSelection = (nextValue: LuggageSelection) => {
    onChange(nextValue, buildLuggagesString(nextValue));
  };

  const handleToggle = (label: LuggageOptionLabel, checked: boolean) => {
    updateSelection({
      ...value,
      selected: {
        ...value.selected,
        [label]: checked,
      },
      quantities: {
        ...value.quantities,
        [label]: checked
          ? Math.max(1, Number(value.quantities[label]) || 1)
          : value.quantities[label],
      },
    });
  };

  const handleQuantityChange = (
    label: LuggageOptionLabel,
    nextValue: number | string | null
  ) => {
    updateSelection({
      ...value,
      selected: {
        ...value.selected,
        [label]: true,
      },
      quantities: {
        ...value.quantities,
        [label]: Math.max(1, Number(nextValue) || 1),
      },
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {LUGGAGE_OPTION_LABELS.map((label) => (
        <div
          key={label}
          style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}
        >
          <Checkbox
            checked={value.selected[label]}
            onChange={(_, checked) => handleToggle(label, checked)}
          >
            {label}
          </Checkbox>
          <InputNumber
            min={1}
            value={value.quantities[label]}
            disabled={!value.selected[label]}
            onChange={(nextValue) => handleQuantityChange(label, nextValue)}
            style={{ width: 120 }}
          />
        </div>
      ))}
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <Checkbox
          checked={value.otherSelected}
          onChange={(_, checked) =>
            updateSelection({
              ...value,
              otherSelected: checked,
            })
          }
        >
          其他
        </Checkbox>
        <Input
          value={value.otherNote}
          disabled={!value.otherSelected}
          onChange={(nextValue) =>
            updateSelection({
              ...value,
              otherSelected: true,
              otherNote: nextValue,
            })
          }
          placeholder="請輸入其他行李說明"
          style={{ flex: 1, minWidth: 220 }}
        />
      </div>
    </div>
  );
}
